// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"QsrOrders_buttonContainer__hiIDu","chatIcon":"QsrOrders_chatIcon__5OpKV"};